module.exports = __webpack_public_path__ + "static/img/images-mail-fail@3x.04a78da6.png";